export const UseDocument = 'Use Document';
export const Pinnedtext = 'Pinned';
export const ClearSessionText = 'Clear Chats';
export const NoSessionFoundText = 'No Session found';
export const TodayText = 'Today';
export const LastDays = 'Last 7 Days';
export const NewSessionText = 'New Chat';
export const AuthTypeText = 'Auth Type';
export const TransPortText = 'Transport Type';
export const URLText = 'URL';
export const NameText = 'Name';
export const AuthenticationText = 'Authentication';
export const TokenText = 'Token';
export const HeadersText = 'Headers';
